import {
  Component,
  ElementRef, EventEmitter,
  Input,
  OnInit, Output,
  QueryList,
  Renderer2,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {BehaviorSubject, merge, Observable, of} from "rxjs";
import {map, shareReplay, switchMap} from "rxjs/operators";
import {FormControl} from "@angular/forms";
import IUniversity from "ecoreps_shared/model/university";
import ICourse from "ecoreps_shared/model/course";

@Component({
  selector: 'k-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class ModalComponent implements OnInit {

  @Input() closable: boolean = true;
  @Input() cancelable: boolean = true;
  @Input() submittable: boolean = true;
  @Input() submitText: string = 'senden';
  @Input() title: string = '';
  @Input() show: boolean = false;

  @Output() submit: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() action: EventEmitter<any> = new EventEmitter<any>();



  public backdropClick() {
    this.close();
  }

  public close() {
    if (this.closable) {
      this.cancel.emit();
      this.action.emit();
    }
  }

  public accept() {
    if (this.submittable) {
      this.submit.emit();
      this.action.emit();
    }
  }

  constructor() {

  }

  ngOnInit() {

  }


}
